const auth0Config = {
  domain: 'farmrail.auth0.com',
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID
};

export default auth0Config;
